import SearchInput, { SearchInputStyles } from "@gemeco/Overrides/Widgets/Header/SearchInput";
import { GemecoState } from "@gemeco/Store/GemecoState";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

export interface StickyHeaderSearchInputStyles {
    searchInputStyles?: SearchInputStyles;
    saerchInputContainer?: InjectableCss;
    searchHeadlineTextStyle?: InjectableCss;
    abrevSearchInputContainer?: InjectableCss;
    abrevSearchHeadlineTextStyle?: InjectableCss;
    abrevContainerStyles?: InjectableCss;
    abrevSearchText?: InjectableCss;
    abrevSearchInput?: InjectableCss;
}

const enum fields {
    searchHeadlineText = "searchHeadlineText",
    backgroundImage = "backgroundImage",
}

const mapStateToProps = (state: GemecoState) => ({
    location: getLocation(state),
    isSecondaryHeader: state.headerPage.isSecondaryHeader,
});

interface OwnProps extends WidgetProps {
    fields: {
        [fields.searchHeadlineText]: string;
        [fields.backgroundImage]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export const searchInputStyles: StickyHeaderSearchInputStyles = {
    abrevSearchInputContainer: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },

    abrevSearchHeadlineTextStyle: {
        css: css`
            height: auto;
        `,
    },

    abrevContainerStyles: {
        css: css`
            display: flex;
            justify-content: center;
        `,
    },

    abrevSearchInput: {
        css: css`
            flex: 0 4 100%;
        `,
    },
};

const styles = searchInputStyles;

const StickyHeaderSearchInput: React.FC<Props> = ({ id, isSecondaryHeader }) => {
    const containerStyle = {
        css: css`
            max-height: ${isSecondaryHeader ? "45" : "0"}px;
            opacity: ${isSecondaryHeader ? "1" : "0"};
            visibility: ${isSecondaryHeader ? "visible" : "hidden"};
            transition: visibility 1s, opacity 1s, max-height 1s;
        `,
    };
    return (
        <StyledWrapper {...containerStyle}>
            <StyledWrapper {...styles.abrevContainerStyles}>
                <StyledWrapper {...styles.abrevSearchInputContainer}>
                    <StyledWrapper className="customHeaderSearchBar" {...styles.abrevSearchInput}>
                        <SearchInput
                            id={id}
                            extendedStyles={styles.searchInputStyles}
                            placeholderText="Search our inventory..."
                        />
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(StickyHeaderSearchInput),
    definition: {
        group: "Header",
        displayName: "Sticky Search Input",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.searchHeadlineText,
                displayName: "Headline Text",
                editorTemplate: "MultilineTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.backgroundImage,
                displayName: "Background Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
